<template>
    <div>
        <v-dialog v-model="dialogVisible" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{ sentenceCaseFn }} {{ title }}
                </v-card-title>

                <v-card-text>
                    <v-text-field
                        v-model="form.name"
                        label="Name"
                        type="text"
                    />
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <div class="white-padding">
                        <v-btn v-if="confFn == 'ADD' " color="primary" class="v-btn-bold-color" @click="confirmAddType()">ADD</v-btn>
                        <v-btn v-if="confFn == 'EDIT' " color="primary" class="v-btn-bold-color" @click="confirmEditType()">EDIT</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data () {
        return {
            form: {
                name: "",
            },
            confFn: "",
            sentenceCaseFn: "",
            payload: {},
            title: null,
        };
    },
    computed: {
        dialogVisible: {
            get: function () {
                var self = this;
                this.confFn = store.state.configurationInfo.fn;
                this.sentenceCaseFn = this.toTitleCase(store.state.configurationInfo.fn);
                this.title = store.state.configurationInfo.title;
                if (store.state.configurationInfo.fn == "EDIT") {
                    self.getForm();
                }
                return store.state.dialog;
            },
            // setter
            set: function (newValue) {
                this.form.name = "";
                this.emptyForm();
                this.payload.isDialog = newValue;

                store.commit("editTableDialog", this.payload);
            }
        }
    },
    methods: {
        confirmAddType() {
            var self = this;
            axios({
                method: "POST",
                url: store.state.configurationInfo.link + "/Create",
                data: {
                    name: self.form.name,
                    code: self.form.name,
                }
            })
                .then(function (response) {
                    store.state.dialog = false;
                    self.form.name = "";
                    self.reloadTable(store.state.configurationInfo.tableName);

                    EventBus.$emit("snackBar", {
					  text: "Row Added",
					  snackbarColor: "green darken-2"
                    });
                });
        },
        confirmEditType() {
            var self = this;
            axios({
                method: "PUT",
                url: store.state.configurationInfo.link + "/Update",
                data: {
                    id: store.state.configurationInfo.id,
                    name: self.form.name,
                    code: self.form.name,
                }
            })
                .then(function (response) {
                    self.reloadTable(store.state.configurationInfo.tableName);
                    self.emptyForm();
                    self.payload.isDialog = false;

                    EventBus.$emit("snackBar", {
					  text: "Row Edited",
					  snackbarColor: "green darken-2"
                    });

                    store.commit("editTableDialog", self.payload);
                });
        },
        getForm() {
            var self = this;
            axios({
                method: "GET",
                url: store.state.configurationInfo.link + "/Get",
                params: {
                    Id: store.state.configurationInfo.id,
                }
            })
                .then(function (response) {
                    self.form.name = response.data.result.name;
                });
        },
        emptyForm() {
            this.form.name         = "";
            this.payload.id        = "";
            this.payload.fn        = "";
            this.payload.link      = "";
            this.payload.tableName = "";
            this.payload.title     = "";
        }
    }
};
</script>

<style scoped>
	.formInlineText{
		margin: 0 1rem;
	}
	.bulletDot{
		width: 7%;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/smallComponents/configurationDialog.vue